export const mqttConfig = {
    hostname: 'wss://www.hexucloud.cn/websocket',
    port: 1883,
    clientId: 'hexu',
    username: 'hx001',
    password: 'hxhj@abc',
    clean: true,
    connectTimeout: 10000,
}